export default "__VITE_ASSET__CGWSL3XD__"